import Header from '../components/CommonComponents/Header';
import NewProjectFlow from '../components/NewProjectFlow';
import Pageheader from '../utils/headerHelment';

const CreateNewProjectPage = () => {
    return (
        <>
            <Pageheader title="LENS - Create Project" />
            <Header hideProjectItems={true} />
            <NewProjectFlow />
        </>
    );
};

export default CreateNewProjectPage;
